module.exports = __webpack_public_path__ + "static/media/SupportButtonIcon.06c0bf37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SupportButtonIcon.svg
// module id = 342
// module chunks = 0